import React from 'react';
import styles from './Industries.module.css';
import useReveal from './useReveal';

const industries = [
  { emoji: '🚀', label: 'Startups' },
  { emoji: '🏢', label: 'Corporate Companies' },
  { emoji: '🛒', label: 'E-commerce Brands' },
  { emoji: '🏨', label: 'Hospitality Businesses' },
  { emoji: '🎓', label: 'Educational Institutions' },
  { emoji: '🔧', label: 'Service-based Companies' },
  { emoji: '📍', label: 'Local Businesses' },
];

export default function Industries() {
  const headRef = useReveal();
  const listRef = useReveal();

  return (
    <section className={styles.section} id="industries">
      <div className={`reveal ${styles.head}`} ref={headRef}>
        <span className="section-label">// industries we serve</span>
        <h2 className="section-title">Built for Every <em>Business</em></h2>
        <p className="section-sub">Our solutions support diverse industries with tailored digital ecosystems.</p>
      </div>
      <div className={`reveal ${styles.pills}`} ref={listRef}>
        {industries.map((ind) => (
          <div key={ind.label} className={styles.pill}>
            <span>{ind.emoji}</span> {ind.label}
          </div>
        ))}
      </div>
    </section>
  );
}
